<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <div class="navbar nav-main w-100" style="background-color:#23409A;color:white">
      <h3 class="w-100 text-center my-3">ชำระเงิน</h3>
    </div>
    <!-- <div class="my-3 session-with-nav  flex-all-center">
      <div>
        <v-img class="my-0 radius-circle" style="width:170px;height:auto" src="@/assets/logo_long.png"></v-img>
      </div>
    </div> -->
    <div class="px-5" style="margin-top: 70px;">
      <Menu :userData="userData" v-if="!nonRegis" />
      <div class="text-center mt-10" v-else-if="nonRegis">
        <div>
          กรุณาลงทะเบียนก่อนการใช้บริการนี้ครับ
        </div>
        <div class="flex-all-center mt-5">
          <v-btn
            color="primary"
            large
            style="color:white;min-width:50%"
            class="main-btn"
            @click="clickRegis"
            >ลงทะเบียน</v-btn
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import VueElementLoading from 'vue-element-loading'
import moment from 'moment'
import Menu from '@/components/payment/menu'
export default {
  components: { Menu, VueElementLoading },
  data() {
    return {
      loading: true,
      selectContact: '',
      contactList: [],
      userData: null,
      nonRegis: false
    }
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId) {
          this.setup()
        }
      }
    }
  },
  mounted() {
    this.setup()
  },
  methods: {
    async setup() {
      await this.fetchUserData(this.userId)
    },
    clickRegis() {
      this.$router.push('/regis')
    },
    async fetchUserData(userId) {
      if (userId) {
        let res = await api.getUser(userId)
        if (res.responsecode == 200 && res.data.id) {
          this.userData = res.data
          this.loading = false
          if (!this.userData.cardnumber) {
            this.nonRegis = true
          }
        } else {
          console.log('error fetch user data')
        }
      }
    }
  },
  computed: {
    query() {
      return this.$store.state.query
    },
    view() {
      return this.$store.state.query.view
    },
    profile() {
      return this.$store.state.profile
    },
    userId() {
      return this.$store.state.profile.userId
    },
    regised() {
      if (this.userId && this.userData && this.userData.cardnumber) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>

<style></style>
